<p style="font-size: 24px;margin-bottom: 25px;"><strong>Inserire criteri di filtro per navigare nel QRSP.</strong></p>

<mat-form-field class="half-width" *ngIf="tipologieCompetenze">
  <mat-label>Tipologia</mat-label>
  <mat-select [(ngModel)]="tipoCompetenza" name="tipologia">
    <mat-option *ngFor="let item of tipologieCompetenze" [value]="item.id">
      {{item.descrizione}}
    </mat-option>
  </mat-select>
</mat-form-field>

<mat-form-field class="half-width">
  <mat-label>Competenza</mat-label>
  <!-- text input -->
  <input matInput placeholder="Profilo professionale" value="{{descrizioneCompetenza}}"
         [(ngModel)]="descrizioneCompetenza" name="descrizione">
</mat-form-field>

<mat-form-field class="half-width" *ngIf="isCompetenzaDiBase">
  <mat-label>Sottocategoria di base</mat-label>
  <mat-select [(ngModel)]="idTipologiaCompDiBase" name="tipologia">
    <mat-option *ngFor="let item of tipologieCompetenzaDiBase" [value]="item.id">
      {{item.descrizione}}
    </mat-option>
  </mat-select>
</mat-form-field>

<button mat-fab extended
        class="searchbox-buttons ricerca-button"
        (click)="filterSearch()"
        [disabled]="atLeastOneFilterInserted">
  <mat-icon>filter_alt</mat-icon>Filtra
</button>

<button mat-fab extended class="searchbox-buttons ripristina-button" (click)="reset()">
  <mat-icon>undo</mat-icon>Ripristina
</button>



<div style="margin-top: 130px; padding: 10px">

  <div style="padding: 50px;">
    <tile
      *ngIf="limitExceeded"
      [displayText]="warningMessageSizeExceeded"
      bgColor="yellow"
      [showWarningIcon]="true"
      [showPointer]="false"
      [showDetailIcon]="false"
    />
  </div>

  <div *ngIf="!competenze.length && fetchedContent" style="display: flex">
    <mat-icon style="color : #008047;margin-top: 10px; margin-left: auto; margin-right: 10px;">sentiment_dissatisfied</mat-icon>
    <p style="font-weight: bold; font-size: 24px;margin-top: 10px; margin-left : 0px; margin-right: auto">La ricerca non ha prodotto alcun risultato...</p>
  </div>
  <div *ngFor="let competenza of competenze;">
    <tile
      [displayText]="competenza.descrizione"
      bgColor="light-green"
      (onView)="detailCompetenza(competenza)"
      (onTileClick)="getAbilitaConoscenze(competenza)"/>


    <div [@slideInOut]="competenza.showChild ? 'in' : 'out'">

     

      <div *ngIf="!mapCompetenzaIdToConoscenza.get(competenza.id)?.length && competenze.quered" style="display: flex">
        <mat-icon style="color : #008047;margin-top: 10px; margin-left: auto; margin-right: 10px;">sentiment_dissatisfied</mat-icon>
        <p style="font-weight: bold; font-size: 24px;margin-top: 10px; margin-left : 0px; margin-right: auto">Non ci sono conoscenze da mostrare per questa competenza</p>
      </div>

      <p *ngIf="mapCompetenzaIdToAbilita.get(competenza.id)?.length && competenza.quered" style="margin-left: 50px; margin-top: 20px; font-size: 20px;"><strong>Conoscenze:</strong></p>

<!--      <div *ngFor="let conoscenza of mapCompetenzaIdToConoscenza.get(competenza.id)">-->
<!--        <tile-->
<!--          [displayText]="conoscenza.descrizione"-->
<!--          bgColor="light-green-inverted"-->
<!--          [showPointer]="false"-->
<!--          [offSetMarginLeft]="40"-->
<!--          [showDetailIcon]="false" />-->
<!--      </div>-->

      <ul style="margin-bottom: 30px;">
        <li  *ngFor="let conoscenza of mapCompetenzaIdToConoscenza.get(competenza.id)">
          {{conoscenza.descrizione}}
        </li>
      </ul>

      <div *ngIf="!mapCompetenzaIdToAbilita.get(competenza.id)?.length && competenza.quered" style="display: flex; margin-top: 30px;">
        <mat-icon style="color : #008047;margin-top: 10px; margin-left: auto; margin-right: 10px;">sentiment_dissatisfied</mat-icon>
        <p style="font-weight: bold; font-size: 24px;margin-top: 10px; margin-left : 0px; margin-right: auto">Non ci sono abilita da mostrare per la competenza selezionata</p>
      </div>

      <p *ngIf="mapCompetenzaIdToAbilita.get(competenza.id)?.length && competenza.quered" style="margin-left: 50px; margin-top: 20px; font-size: 20px;"><strong>Abilità:</strong></p>

<!--      <div *ngFor="let abilita of mapCompetenzaIdToAbilita.get(competenza.id)">-->
<!--        <tile-->
<!--          [displayText]="abilita.descrizione"-->
<!--          [showPointer]="false"-->
<!--          bgColor="light-green-inverted"-->
<!--          [offSetMarginLeft]="40"-->
<!--          [showDetailIcon]="false" />-->
<!--      </div>-->

      <ul>
        <li  *ngFor="let abilita of mapCompetenzaIdToAbilita.get(competenza.id) ">
          {{abilita.descrizione}}
        </li>
      </ul>
    </div>
  </div>
</div>
